import { PostcodeLookupAddress } from '@/api/lookups/postcodeLookup';
import { SchoolLookupAddress } from '@/api/lookups/schoolLookup';

/**
 * Maps lookup address results to standard address fields
 * @param result - The lookup result (either postcode or school lookup)
 * @param isSchool - Optional. Whether this is a school lookup (different structure and includes establishment name). Defaults to false.
 */
export function mapLookupToAddress(
  result: PostcodeLookupAddress | SchoolLookupAddress,
  isSchool = false
) {
  if (isSchool) {
    const schoolResult = result as SchoolLookupAddress;
    if (!schoolResult?.address_1 || !schoolResult?.post_code) {
      throw new Error('Selected address result did not contain address1 or a postcode');
    }

    return {
      establishmentName: schoolResult.name,
      postcode: schoolResult.post_code,
      address1: schoolResult.address_1,
      address2: schoolResult.address_2 ?? '',
      address3: schoolResult.address_3 ?? '',
      town: schoolResult.town,
    };
  }
  const postcodeResult = result as PostcodeLookupAddress;
  if (!postcodeResult?.Line1 || !postcodeResult?.postcode) {
    throw new Error('Selected address result did not contain a first line or a postcode');
  }

  return {
    postcode: postcodeResult.postcode,
    address1: postcodeResult.Line1,
    address2: postcodeResult.Line2 ?? '',
    address3: postcodeResult.Line3 ?? '',
    town: postcodeResult.posttown,
  };
}
